// This is an attempt to have an agnostic Contentful post listing comp.
// The idea is to have this for both CaseStudies, Blog and whatever looks like
// a Story box.
import { Component } from "react"
import PropTypes from "prop-types"
import Qs from "qs"

import StoryCard from "shared/components/get_more/story_card"

import { partialStoryShape } from "app/lib/shared_prop_types"
import { get } from "shared/lib/api"

export default class ContentfulPostListing extends Component {
  state = {
    stories: this.props.stories,
    loadedEverything: this.props.loadedEverything,
  }

  getMore = () => {
    const params = Qs.stringify({ offset: this.state.stories.length })

    get(`/${this.props.singleStoryBasePath}?${params}`)
      .then(resp => {
        this.setState({
          stories: [...this.state.stories, ...resp.posts],
          loadedEverything: resp.loadedEverything,
        })
      })
      .catch(() =>
        window.appendFlash(
          "Couldn't load more posts. Please try again later.",
          "danger"
        )
      )
  }

  render() {
    const stories = this.state.stories.map((story, k) => {
      return (
        <StoryCard
          story={story}
          position={k}
          key={k}
          singleStoryBasePath={this.props.singleStoryBasePath}
        />
      )
    })
    return (
      <>
        <div className="post-listing-container">{stories}</div>
        {!this.state.loadedEverything && (
          <div className="view-more">
            <button
              className="button-primary button-outlined"
              onClick={this.getMore}
            >
              View more
            </button>
          </div>
        )}
      </>
    )
  }
}

ContentfulPostListing.propTypes = {
  stories: PropTypes.arrayOf(partialStoryShape),
  singleStoryBasePath: PropTypes.string,
  loadedEverything: PropTypes.bool,
}

ContentfulPostListing.defaultProps = {
  stories: [],
  loadedEverything: false,
}
